import React from 'react';
import { useEffect, useState } from 'react';
import { get_connections } from '../connections';
import Kubernetes from './deployment_types/kubernetes/Kubernetes';
import './DeploymentSettings.css'
import { Back } from '../../../../../../../components/back/Back';


const DeploymentSettings = ({ data, serviceName, projectId, setDeployment, next, back, direction }) => {
    const [currentPage, setCurrentPage] = useState(direction === "forward" ? "type" : "setting")
    const [connections, setConnections] = useState([])
    const [settings, setSettings] = useState(Object.keys(data).length > 0 ? data : 
        {
            deployment_type: "",
            connector_id: 0,
        })

    // const get_deployment = () => {
    //     console.log(settings)
    //     if(settings.deployment_type === "K8s"){
    //         return <Kubernetes serviceName={serviceName} projectId={projectId} setDeployment={setDeployment} next={next} preSetting={settings} back={()=>{setCurrentPage("type")}} direction={direction}/>
    //     }
    // }

    useEffect(() => {get_connections(setConnections,"", "kubernetes", projectId)}, []);

    useEffect(() => {
        if (connections.length != 0 && settings.connector_id == 0){
            setSettings( {
                ...settings,
                connector_id: connections[0].id,
                deployment_type: connections[0].connector_type,
            });
        }
        else if(connections.length != 0) {
            connections.map(connection => {
                if (connection.id == settings.connector_id) {
                    setSettings({
                        ...settings,
                        deployment_type: connection.connector_type,
                    });
                }
            })
        }
    }, [connections]);

    useEffect(()=>
        {
            setCurrentPage(direction === "forward" ? "type" : "settings")
        },
        [direction])
    
    
    return ( 
        currentPage === "type" ?
            <div className='new-service-deployment-setting-type'>
                <Back back={back}/>
                <h1>Infrastructure</h1>
                <div className='info-blocks'>
                    {/* <div className='info-block deployment-type'>
                        <label>Deployment Type:</label>
                        <label className='deployment-type-input'>{settings.deployment_type}</label>
                    </div> */}
                    <div className='info-block'>
                        <label>Connector:</label>
                        <select
                            id="connector"
                            value={settings.connector_id}
                            onChange={(e) => {
                                const selectedId = parseInt(e.target.value);
                                const selectedConnection = connections.find(conn => conn.id === selectedId);
                        
                                if (selectedConnection) {
                                    setSettings({
                                        ...settings,
                                        connector_id: selectedConnection.id,
                                        deployment_type: selectedConnection.connector_type,
                                    });
                                }
                            }}
                        >
                            {connections.map((connection) => (
                                <option key={connection.id} value={connection.id}>
                                    {connection.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <button className='next-button' onClick={()=>{setCurrentPage("settings")}}>next</button>
            </div>
        : currentPage === "settings"  && settings.deployment_type === "K8s" ? 
            <Kubernetes serviceName={serviceName} projectId={projectId} setDeployment={setDeployment} next={next} preSetting={settings} back={()=>{setCurrentPage("type")}} direction={direction}/>
         : <div/>

    );
};

export default DeploymentSettings;